/* eslint-disable prettier/prettier */
import React, { type JSX } from 'react';
import { useConfirm, useDashboardCommonHandlers } from '@fiji/common/src/hooks';
import { Typography } from '@mui/material';
import { CustomModal, ModalActions } from 'components/CustomModal';
import { CustomTransComponent } from 'components';
import { useParams } from 'react-router-dom';

type ModalProps = {
    widgetID?: string;
    'data-testid'?: string;
    onConfirmCommand?: (data: any, widgetId: string) => void;
};

export const AddConfirmationModal = React.forwardRef(
    ({ widgetID, 'data-testid': dataTestId, onConfirmCommand }: ModalProps, ref): JSX.Element => {
        const { deviceId } = useParams();
        const [widgetData, setWidgetData] = React.useState<any>(null);
        const { handleDeviceCommands } = useDashboardCommonHandlers(deviceId);

        const { isVisible, onClick, onCancel, onConfirm } = useConfirm((data: any) => {
            if (onConfirmCommand) {
                onConfirmCommand(data, widgetID!);
            } else {
                void handleDeviceCommands(data, widgetID);
            }
            onCancel();
        });

        const handleModalAction = (action: boolean, data?: any): void => {
            if (action) {
                setWidgetData(data);
                onClick(data);
                return;
            }
            onCancel();
        };

        React.useImperativeHandle(
            ref,
            () => ({
                handleModalAction: (action: boolean, data: any): void => handleModalAction(action, data),
            }),
            []
        );
        const removeActions: ModalActions[] = [
            {
                testId: 'cancelBtn',
                key: 'cancel',
                label: <CustomTransComponent translationKey={'COMMON:CANCEL'} />,
                close: true,
                variant: 'outlined',
                handleClick: (): void => {
                    onCancel(true);
                },
            },
            {
                testId: 'commandName',
                key: 'commandName',
                label: `${widgetData?.displayName}`,
                variant: 'contained',
                handleClick: onConfirm,
            },
        ];
        return (
            <CustomModal
                type="primary"
                header={`${widgetData?.displayName}?`}
                isOpen={isVisible}
                actions={removeActions}
                noDividers
                actionsDivider
                data-testid={dataTestId ?? 'custom-modal'}
            >
                <Typography>
                    <CustomTransComponent translationKey={`WIDGET_MANAGEMENT:SELECT`} /> {'`'}
                    {widgetData?.displayName}
                    {'`'} <CustomTransComponent translationKey={`WIDGET_MANAGEMENT:CMD_BAR_CONFIRM_TEXT`} />
                    {'.'}
                </Typography>
            </CustomModal>
        );
    }
);
